export const FILTERS = {
  READS: 'READS',
  TITLE: 'TITLE',
  UPDATED_AT: 'UPDATED_AT',
  CREATED_AT: 'CREATED_AT',
  SALE_DATE: 'SALE_DATE',
  RELEASE_DATE: 'RELEASE_DATE',
}

export const ORDERING = {
  ASC: 'ASC',
  DESC: 'DESC',
}
